"use client";

import { ProductLayoutType } from "@/util/query/general-styles-query";
import React, { createContext, ReactNode, useEffect, useState, useContext } from "react";

export type ProductLayoutStylesInput = Partial<ProductLayoutType> | null | undefined;

const ProductLayoutStyleContext = createContext<ProductLayoutType>({} as ProductLayoutType);


export const ProductLayoutProvider = ({
    children,
    productLayoutStyle,
}:{
    children: ReactNode;
    productLayoutStyle: ProductLayoutStylesInput;
}) => {
    const [data, setData] = useState<ProductLayoutType>({
        productColumns: 4,
        productRows: 3,
        productCardType: "TYPE_1",
        mobileColumn: 2,
        arrowPosition: "BOTTOM",
        favoriteEnable: true,
    });


    useEffect(() => {
        if (!productLayoutStyle) return;

        setData((prev) => ({
            productColumns: productLayoutStyle.productColumns ?? prev.productColumns,
            productRows: productLayoutStyle.productRows ?? prev.productRows,
            productCardType: productLayoutStyle.productCardType ?? prev.productCardType,
            mobileColumn: productLayoutStyle.mobileColumn ?? prev.mobileColumn,
            arrowPosition: productLayoutStyle.arrowPosition ?? prev.arrowPosition,
            favoriteEnable: productLayoutStyle.favoriteEnable ?? prev.favoriteEnable,
        }));
    }, [productLayoutStyle]);

    return (
        <ProductLayoutStyleContext.Provider value={data}>
            {children}
        </ProductLayoutStyleContext.Provider>
    );
}

export default ProductLayoutStyleContext;

export const useProductLayout = () => useContext(ProductLayoutStyleContext);
